import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ValidationUtilityService } from '../../shared/utils/validation.util/validation-utility.service';
import { MASK_CONSTANTS } from '../../../constants/mask.constants';
import { ServiceRouter } from '../../../services/core/http-service-router.service';
import { Subscription } from 'rxjs';
import { Environment } from '../../../config/environment';
import { METHOD_TYPE } from '../../../constants/service.constants';
import { JwtHelper } from '../../../services/core/jwt-helper.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SpinnerComponent } from '../../shared/spinner/spinner.component';
import { MAX_SSN_FAILURE_ATTEMPTS } from '../../../constants/health-record.constants';
import { Config } from 'src/app/config/config';

@Component({
	selector: 'app-ssn-verification-modal',
	templateUrl: './ssn-verification-modal.component.html',
	styleUrls: ['./ssn-verification-modal.component.scss'],
})
export class SsnVerificationModalComponent implements OnInit, OnDestroy {
	ssnVerification: FormGroup;
	ssnMask: any = MASK_CONSTANTS.SSN;
	subscription: Subscription;
	showCouldNotVerifySsn = false;
	errorMessage: any = { show: false, attempt: 0 };
	title: any = 'Verification';
	showButtons: boolean;
	attempts: number;
	showhideSSNVal = false;
	constructor(
		private config: Config,
		private serviceRouter: ServiceRouter,
		private environment: Environment,
		private jwtService: JwtHelper,
		private dialogRef: MatDialogRef<SsnVerificationModalComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private spinner: SpinnerComponent
	) {}

	ngOnInit() {
		this.showButtons = true;
		this.ssnVerification = new FormGroup({
			ssn: new FormControl('', Validators.compose([Validators.required, ValidationUtilityService.ssnValidator])),
		});
		this.ssnVerification.valueChanges.subscribe(value => {
			this.errorMessage.show = false;
		});
	}

	showHideSSN() {
		this.showhideSSNVal = !this.showhideSSNVal;
	}

	getAction(actionType: string): void {
		if (actionType === 'SUBMIT') {
			this.validateSSN();
		} else if (actionType === 'CLOSE' && !this.showCouldNotVerifySsn) {
			this.showCouldNotVerifySsn = true;
			this.showButtons = false;
			this.title = 'We cannot verify your Social Security number.';
		} else {
			this.dialogRef.close({ ssnVerified: false, attempts: this.attempts });
		}
	}

	validateSSN() {
		if (this.ssnVerification.valid) {
			this.ssnVerification.get('ssn').markAsTouched();
			const userSSN = this.ssnVerification.getRawValue();
			const epmsPID = this.jwtService.getEpmsId();
			const url = `${this.config.url.profileApi.baseUrl}/${epmsPID}/validateSSN`;
			this.validateSSNServiceCall(userSSN, url);
		}
	}

	validateSSNServiceCall(userSSN: any, serviceUrl: string) {
		this.spinner.startLoader();
		this.subscription = this.serviceRouter
			.makeRequest(this.environment.getEnvironment().EPMS_PROXY_BASE_URL, serviceUrl, METHOD_TYPE.SECURED_POST, userSSN)
			.subscribe(
				res => {
					setTimeout(() => {
						this.spinner.stopLoader();
					}, 10);
					this.dialogRef.close({ ssnVerified: true });
				},
				err => {
					this.spinner.stopLoader();
					this.attempts = +err.message;
					this.errorMessage = {
						show: true,
						attempt: MAX_SSN_FAILURE_ATTEMPTS - err.message,
					};
					if (err.message > MAX_SSN_FAILURE_ATTEMPTS || MAX_SSN_FAILURE_ATTEMPTS === this.attempts) {
						this.showButtons = false;
						this.showCouldNotVerifySsn = true;
					}
				}
			);
	}

	ngOnDestroy() {
		if (this.subscription) {
			this.subscription.unsubscribe();
		}
	}
}
